import React from 'react';
import clsx from 'clsx';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    padding?: 'none' | 'sm' | 'md' | 'lg';
    elevation?: 'default' | 'flat' | 'raised' | 'brand' | 'sunken';
    /** Lifts 3px on hover */
    interactive?: boolean;
    /** @deprecated use interactive */
    hoverable?: boolean;
    /** @deprecated use interactive */
    clickable?: boolean;
    /** Selected = 2px plum border */
    selected?: boolean;
}

const paddings = { none: '', sm: 'p-4', md: 'p-5', lg: 'p-6' };
const elevations = {
    default: 'bg-surface-card border border-line-subtle shadow-sm',
    flat: 'bg-surface-card border border-line-subtle',
    raised: 'bg-surface-card shadow-lg',
    brand: 'bg-surface-brand text-white shadow-brand',
    sunken: 'bg-surface-sunken',
};

/** 20px-radius surface. */
export const Card: React.FC<CardProps> = ({ padding = 'md', elevation = 'default', interactive, hoverable, clickable, selected, className, children, ...props }) => (
    <div
        className={clsx(
            'rounded-lg',
            elevations[elevation],
            paddings[padding],
            (interactive || hoverable || clickable) && 'cursor-pointer transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-[3px] hover:shadow-lg active:-translate-y-px',
            selected && '!border-2 !border-primary-500',
            className,
        )}
        {...props}
    >
        {children}
    </div>
);
export default Card;
